/**
 * Spanish/Catalan-style euro display: amount first, comma decimals, symbol after.
 * Examples: "12 €", "12,50 €"
 */

export type FormatPriceEurOptions = {
  /** Shown when price is null/invalid. Default: "? €" */
  missing?: string;
};

function isWholeEuro(amount: number): boolean {
  return Math.abs(amount - Math.round(amount)) < 1e-9;
}

export function formatPriceEur(
  priceEur: number | null | undefined,
  options?: FormatPriceEurOptions
): string {
  if (priceEur == null || Number.isNaN(priceEur)) {
    return options?.missing ?? "? €";
  }

  const normalized = Math.round(priceEur * 100) / 100;

  if (isWholeEuro(normalized)) {
    return `${Math.round(normalized)} €`;
  }

  return `${normalized.toFixed(2).replace(".", ",")} €`;
}

/** Like formatPriceEur but returns null when price is absent (for optional UI slots). */
export function formatPriceEurIfPresent(
  priceEur: number | null | undefined
): string | null {
  if (priceEur == null || Number.isNaN(priceEur)) return null;
  return formatPriceEur(priceEur);
}

/** Map markers and explore list pills — same rules as formatPriceEur. */
export function formatPriceLabel(priceEur: number | null | undefined): string {
  return formatPriceEur(priceEur);
}
